// ------------------------------------
//
// STOMP - SHOPIFY DEVELOPMENT
//
// ------------------------------------



// -----------------------------------------  COMMON: MOBILE MENU -----------------------------------------
  

let screenWidth = $(window).width();
window.addEventListener("resize", function(){
    screenWidth = $(window).width();
    if( screenWidth > 767) {
        $("#footer .f_mid .row div:nth-child(1) ul").css("display", "block");
        $("#footer .f_mid .row div:nth-child(2) ul").css("display", "block");
        $("#footer .f_mid .row div:nth-child(3) ul").css("display", "block");
        $("#footer .f_mid .signup_col").css("display", "block");
    } else {
        $("#footer .f_mid .row div:nth-child(1) ul").css("display", "none");
        $("#footer .f_mid .row div:nth-child(2) ul").css("display", "none");
        $("#footer .f_mid .row div:nth-child(3) ul").css("display", "none");
        $("#footer .f_mid .signup_col").css("display", "none");
    }
});
$("#footer .f_mid .row div:nth-child(1) h2").on("click", function() {
    if( screenWidth < 768) {
        $("#footer .f_mid .row div:nth-child(1) ul").slideToggle('fast');
    }
});

$("#footer .f_mid .row div:nth-child(2) h2").on("click", function() {
    if( screenWidth < 768) {
        $("#footer .f_mid .row div:nth-child(2) ul").slideToggle('fast');
    }
});
    
$("#footer .f_mid .row div:nth-child(3) h2").on("click", function() {
    if( screenWidth < 768) {
        $("#footer .f_mid .row div:nth-child(3) ul").slideToggle('fast');
    }
});

$("#footer .f_mid .signup_title").on("click", function() {
    if( screenWidth < 768) {
        $("#footer .f_mid .signup_col").slideToggle('fast');
    }
});

function appendSmileIONumbers() {
    var num1 = document.createElement('h1');
    var num2 = document.createElement('h1');
    var num3 = document.createElement('h1');

    var num1Ref = document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(1) .slp_8dbfc7');
    var num2Ref = document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(2) .slp_8dbfc7');
    var num3Ref = document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(3) .slp_8dbfc7');

    const num1Content = document.createTextNode("1.");
    const num2Content = document.createTextNode("2.");
    const num3Content = document.createTextNode("3.");

    num1.appendChild(num1Content);
    num2.appendChild(num2Content);
    num3.appendChild(num3Content);

    num1Ref?.parentNode.insertBefore(num1, num1Ref);
    num2Ref?.parentNode.insertBefore(num2, num2Ref);
    num3Ref?.parentNode.insertBefore(num3, num3Ref);
}
function howItWorksTextChange() {
    if(document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(1) .slp_8dbfc7') && 
     document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(2) .slp_8dbfc7') && 
     document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(3) .slp_8dbfc7')
    ){
      document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(1) .slp_8dbfc7').innerText = "Sign up and create an account with us";
      document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(2) .slp_8dbfc7').innerText = "Start earning on your first purchase";
      document.querySelector('.slp_33f387 .slp_fcec57.slp_1f002c.slp_4f77b0.slp_c33c9b:nth-of-type(3) .slp_8dbfc7').innerText = "Spend your points & get rewarded";
    }
}
setTimeout(howItWorksTextChange, 1000);
setTimeout(appendSmileIONumbers, 1000);